import { lazy } from "react";
import { CANCEL } from "pages/routes/route.constant";
const cancel = lazy(() => import("pages/Cancel"));

export default {
  path: CANCEL,
  element: cancel,
};
